import { getCategoriesChain, getSectionById } from '@/entities/categories'

import { CatalogItemLocation, TSection } from '@/shared/types/deprecated-types'
import { TProduct } from '@/shared/types/product-types'

export const getProductClick = (
	product: TProduct,
	location: `${CatalogItemLocation}`,
	position: number,
	allCategories: TSection[]
): Record<string, unknown> | null => {
	const productCategory = getSectionById(allCategories, product.SECTION_ID)
	const categoriesChain = getCategoriesChain(productCategory, allCategories)

	return {
		event: 'product_click',
		ecommerce: {
			currencyCode: `RUB`,
			click: {
				products: [
					{
						name: product.TITLE,
						id: product.KOD,
						price: product.PRICE.VALUE,
						brand: product.PROPERTIES?.osnovnye_parametry?.GROUP_PROPERTIES?.PROIZVODITEL?.values[0],
						category: categoriesChain,
						position
					}
				]
			}
		}
	}
}
